module.exports = __webpack_public_path__ + "static/media/welcomePicture2.794239a7.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/welcomePicture2.jpeg
// module id = 389
// module chunks = 0